import { css, cx } from "@emotion/css"
import { compactSmall } from "../../helpers/formatters"
import { stylesWidgetStats } from "../../styles"

const styles = {
  amount: css`
    width: 68px;
    height: 25px;
    flex-grow: 0;
    text-align: left;
    color: var(--white);
  `,
  detail: css`
    flex-grow: 0;
    text-align: left;
    color: var(--white);
  `,
  detailSub: css`
    height: 14px;
    flex-grow: 0;
    opacity: 0.6;
    text-align: left;
    color: var(--white);
    padding-top: var(--spacing-xxs);
  `,
}

type WidgetStatsPieProps = {
  currency: string
  current?: number
  note: string
  percentage?: number | null
  subnote: string
  subnote2?: string
}
export const StatsPieInfo = (props: WidgetStatsPieProps) => {
  const { currency, current, note, subnote, percentage, subnote2 } = props

  return (
    <>
      <div
        className={cx(
          "HeadingH4Regular",
          styles.amount,
          stylesWidgetStats.topElement,
        )}
      >
        {current !== null ? `${currency}${compactSmall(current)}` : "N/A"}
      </div>
      <div
        className={cx(
          "HeadingH5bBold",
          styles.detail,
          stylesWidgetStats.topElement,
        )}
      >
        {note}
      </div>
      <div
        className={cx(
          "BodyBody1Regular",
          styles.detailSub,
          stylesWidgetStats.topElement,
        )}
      >
        {percentage !== null ? `${compactSmall(percentage)}% ` : "N/A"}
        {percentage !== null && subnote}
        {subnote2 ? <div>{subnote2}</div> : null}
      </div>
    </>
  )
}
